// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"b6f5e46c","452":"74c9b10b","453":"470c3363"}[chunkId] + ".chunk.js";
};